import EnlilAxios from "../../../../util/EnlilAxios";
import {V1DeveloperSubscriptionIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class DeveloperSubscriptionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t2/v1/developer_subscriptions",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                //"Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.DeveloperSubscription-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1DeveloperSubscriptionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.DeveloperSubscription-001";
        payload.ShifamedMessage.DeveloperSubscription = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t2/v1/developer_subscriptions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.DeveloperSubscription-001",
                "idoc-response": "v1.DeveloperSubscription-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1DeveloperSubscriptionIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let developerSubscription = {};

        developerSubscription["USID"] = this.getAttributeValue("USID");
        developerSubscription["Name"] = this.getAttributeValue("Name");
        developerSubscription["Status"] = this.getAttributeValue("Status");
        developerSubscription["EventType"] = this.getAttributeValue("EventType");
        developerSubscription["NotificationURL"] = this.getAttributeValue("NotificationURL");
        developerSubscription["SecurityKey"] = this.getAttributeValue("SecurityKey");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.DeveloperSubscription-001";
        payload.ShifamedMessage.DeveloperSubscription = developerSubscription;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t2/v1/developer_subscriptions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.DeveloperSubscription-001",
                "idoc-response": "v1.DeveloperSubscription-001",
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1DeveloperSubscriptionIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentDeleteIDOC = () => {
        let payload = {};

        let developerSubscription = {};

        developerSubscription["USID"] = this.getAttributeValue("USID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.DeveloperSubscription-002";
        payload.ShifamedMessage.DeveloperSubscription = developerSubscription;

        return payload;
    };

    performDelete() {
        let payload = this.enterpriseComponentDeleteIDOC();

        let options = {
            method: "DELETE",
            url: "t2/v1/developer_subscriptions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.DeveloperSubscription-002",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };

}

export default DeveloperSubscriptionEnterpriseComponent;